package gr.tech.site.util

sealed class ImageRepo(val src: String, val alt: String) {

    // Random
    data object MoneyBackground: ImageRepo(src = "/images/moneybackground.png", alt="Wall of Cash")
    data object LEDGrowLights: ImageRepo(src = "/images/ledgrowlights.jpg", alt="LED Grow Lights & Plants")
    data object LEDGrowLights2: ImageRepo(src = "/images/ledgrowlights2.jpg", alt="LED Grow Lights & Plants")
    data object Dehumidifier: ImageRepo(src = "/images/dehumidifier.png", alt="Dehumidifier & Plants")

    // Team members
    data object DylanCollins1: ImageRepo(src = "/images/team/dylancollins.jpg", alt="Dylan Collins")
    data object EthanCohen1: ImageRepo(src = "/images/team/ethancohen.jpg", alt="Close up of Cannabis plant")

    // Cannabis Images
    data object CannabisPhoto: ImageRepo(src = "/images/cannabiscloseup1.webp", alt="Close up of Cannabis plant")

    // State Photos
    data object Michigan1: ImageRepo(src = "/images/michigan1.webp", alt="Lake Michigan")
    data object Minnesota1: ImageRepo(src = "/images/minnesota1.jpg", alt="Minneapolis Minnesota")
    data object Washington1: ImageRepo(src = "/images/washington1.jpg", alt="Washington State Pacific Northwest")
    data object Oregon1: ImageRepo(src = "/images/oregon1.jpg", alt="Oregon Pacific Northwest")

    // Article Photos
    data object RebatesVsIncentives: ImageRepo(src = "/images/article/rebatesvsincentives.jpg", alt = "Rows of grow plants")
    data object EnergySavings: ImageRepo(src = "/images/article/energysavings.jpg", alt = "Rows of grow plants")
    data object HowEnergyIncentives: ImageRepo(src = "/images/article/howenergyincentives.jpg", alt = "Rows of grow plants")
    data object BrighteningFuture: ImageRepo(src = "/images/article/brightiningthefuture.png", alt = "Rows of grow plants")

    // Blog Photos
    data object GreenRebatesAward: ImageRepo(src = "/images/blog/greenrebateswinprestigious.png", alt = "Green Rebates Award")


}